module.exports = __webpack_public_path__ + "static/media/edinburgh.70f333b6.png";